module.exports = __webpack_public_path__ + "static/media/github-visual-editor.d0d36514.png";